import { __spreadArrays } from "tslib";
import { times, } from "../constants";
import { matchUnit } from "./util";
export var timeFormatUnits = [times];
export var timeFormatUnitIds = [].concat.apply([], timeFormatUnits.map(function (timeFormatUnitGroup) { return __spreadArrays(timeFormatUnitGroup.map(function (timeFormatUnit) { return timeFormatUnit.id; }), [].concat.apply([], timeFormatUnitGroup.map(function (timeFormatUnit) {
    return timeFormatUnit.alias ? timeFormatUnit.alias : [];
}))); }));
export function humanizeTimeValue(value, unit, targetUnit) {
    var baseTimeUnitGroupIndex = 0;
    var baseTimeUnitIndex = 2;
    var targetTimeUnitIndex = -1;
    if (unit) {
        var _loop_1 = function (i) {
            var _baseTimeUnitIndex = -1;
            var _targetTimeUnitIndex = -1;
            timeFormatUnits[i].forEach(function (timeUnit, index) {
                if (matchUnit(timeUnit, unit))
                    _baseTimeUnitIndex = index;
                if (matchUnit(timeUnit, targetUnit))
                    _targetTimeUnitIndex = index;
            });
            if (_baseTimeUnitIndex !== -1) {
                baseTimeUnitGroupIndex = i;
                baseTimeUnitIndex = _baseTimeUnitIndex;
                targetTimeUnitIndex = _targetTimeUnitIndex;
                return "break";
            }
        };
        for (var i = 0; i < timeFormatUnits.length; ++i) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
    }
    else if (targetUnit) {
        targetTimeUnitIndex = timeFormatUnits[baseTimeUnitGroupIndex].findIndex(function (timeUnit) { return matchUnit(timeUnit, targetUnit); });
    }
    var timeFormatUnitGroup = timeFormatUnits[baseTimeUnitGroupIndex];
    var baseTimeFormatUnit = timeFormatUnitGroup[baseTimeUnitIndex];
    var targetTimeFormatUnit = baseTimeFormatUnit;
    if (targetTimeUnitIndex === -1) {
        for (var i = baseTimeUnitIndex + 1; i < timeFormatUnitGroup.length; ++i) {
            if (value / (timeFormatUnitGroup[i].divisor / baseTimeFormatUnit.divisor) >=
                1) {
                targetTimeFormatUnit = timeFormatUnitGroup[i];
            }
            else {
                break;
            }
        }
    }
    else {
        targetTimeFormatUnit = timeFormatUnitGroup[targetTimeUnitIndex];
    }
    if (targetUnit && targetTimeUnitIndex === -1) {
        console.warn("Cannot convert unit \"" + (unit || baseTimeFormatUnit.display) + "\" to \"" + targetUnit + "\"");
    }
    return [
        value / (targetTimeFormatUnit.divisor / baseTimeFormatUnit.divisor),
        targetTimeFormatUnit.display,
    ];
}
//# sourceMappingURL=time.js.map